import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import CategoriesState from '../../types/CategoriesState'

export const categoriesModule: Module<CategoriesState, RootState> = {
  namespaced: true,
  state: {
    categories: [],
    current_category: null,
    loadedForLocationCode: null
  },
  getters,
  actions,
  mutations
}
